import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

interface ChipAutocompleteStylesProps {
  wrapSelection?: boolean
}
const useStyles = makeStyles<Theme, ChipAutocompleteStylesProps>(theme => ({
  textField: {
    width: '100%'
  },

  textFieldInput: {
    font: 'inherit',
    flexWrap: ({ wrapSelection }) => (wrapSelection ? 'wrap' : 'nowrap'),

    '& .MuiInput-input': {
      width: ({ wrapSelection }) => wrapSelection && 0,
      minWidth: ({ wrapSelection }) => wrapSelection && 50
    }
  },

  suggestion: {
    padding: '12px 16px'
  }
}))

export default useStyles
